import { Snackbar, SnackbarProps } from "../Snackbar";
export const Toast = Snackbar;
export interface ToastProps extends SnackbarProps {}
